/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
//Custom libraries
// Create our number formatter.
export const formatterUS = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

export const formatterPEN = new Intl.NumberFormat("es-PE", {
  style: "currency",
  currency: "PEN",
});

export const formatterMXN = new Intl.NumberFormat("es-MX", {
  style: "currency",
  currency: "MXN",
});

export const currencyFormat = (currenyCode: string, amount: number) => {
  let formatter: Intl.NumberFormat = formatterUS;

  switch (currenyCode) {
    case "USD":
      formatter = formatterUS;
      break;
    case "PEN":
      formatter = formatterPEN;
      break;
    case "MXN":
      formatter = formatterMXN;
      break;
  }

  return formatter.format(amount);
};
